var index = {
   namespaced: true,
   state: {
      page: null
   },
   mutations: {
      setPage(state, page) {
         state.page = page;
      }
   }
};

export default index;
